import React from 'react';
import { cn } from '../../lib/cn';
import { Masthead } from '../shell/Masthead';

interface PageWrapperProps {
  title: string;
  subtitle?: string;
  meta?: React.ReactNode;
  children: React.ReactNode;
  loading?: boolean;
  maxWidth?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | false;
  noPaper?: boolean;
  actions?: React.ReactNode;
}

const MAX_WIDTH_CLASSES: Record<'xs' | 'sm' | 'md' | 'lg' | 'xl', string> = {
  xs: 'max-w-md',
  sm: 'max-w-2xl',
  md: 'max-w-3xl',
  lg: 'max-w-5xl',
  xl: 'max-w-7xl',
};

export const PageWrapper: React.FC<PageWrapperProps> = ({
  title, subtitle, meta, children, loading = false,
  maxWidth = 'lg', noPaper = false, actions,
}) => (
  <div className={cn('mx-auto px-4 py-3', maxWidth !== false && MAX_WIDTH_CLASSES[maxWidth])}>
    {loading ? (
      <div role="status" aria-label="Loading" data-testid="page-wrapper-skeleton" className="animate-pulse space-y-4">
        <div className="h-11 w-[300px] max-w-full border-b border-rule-faint" />
        <div className="h-[200px] border border-rule-faint bg-paper-raised" />
        <div className="h-[300px] border border-rule-faint bg-paper-raised" />
        <span className="sr-only">Loading…</span>
      </div>
    ) : (
      <>
        <Masthead title={title} summary={subtitle} meta={meta} actions={actions} />
        {noPaper ? children : <div className="border border-ink bg-paper-raised p-4">{children}</div>}
      </>
    )}
  </div>
);
